var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNervos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 57,
    viewBox: "0 0 68 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V11.395V22.7899V34.2099H11.3018V22.7899V11.395V0H0Z",
    fill: "white",
    fillOpacity: 0.84
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.062 22.7899V34.2099V45.6049V56.9999H67.3638V45.6049V34.2099V22.7899H56.062Z",
    fill: "white",
    fillOpacity: 0.84
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4333 0V11.395V22.3141L44.7351 33.7091V22.7899V11.395L33.4333 0Z",
    fill: "white",
    fillOpacity: 0.84
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6287 23.2909V34.21V45.605L33.9305 57V45.605V34.6859L22.6287 23.2909Z",
    fill: "white",
    fillOpacity: 0.84
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4333 0H44.7351L67.3636 22.7899H56.0618L33.4333 0Z",
    fill: "white",
    fillOpacity: 0.76
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.2101H11.3018L33.9302 57H22.6284L0 34.2101Z",
    fill: "white",
    fillOpacity: 0.76
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7353 11.395V22.7899V33.5588L11.3019 0V11.395V12.0962V22.7899V34.21L22.6285 45.6049V34.21V23.4411L56.0619 56.9999V45.6049V44.9037V34.21V22.7899L44.7353 11.395Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNervos);
export default __webpack_public_path__ + "static/media/Nervos.e7319359cc2e717fd15d2aa59b4d9fce.svg";
export { ForwardRef as ReactComponent };